export default "__VITE_ASSET__flk$iCle__"